import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from '../../backendService';
import { JaaSMeeting, JitsiMeeting } from '@jitsi/react-sdk';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';

const YOUR_DOMAIN = 'meet.heliumlearn.com';
// const YOUR_DOMAIN = 'meet.grannydr.com';
// const YOUR_DOMAIN = 'meet.jit.si';
// const YOUR_DOMAIN = 'jitsi_helium.heliumlearn';

const JoinLiveLecture = ({ roomName, id, name, email }) => {
  const [jwtToken, setJwtToken] = useState('');

  const navigate = useNavigate();
  const goBack = async () => {
    try {
      const response = await axios.post(`/videos/createSessionWithThumbnailUrls/make-session-disable/${roomName}`);
      if (response.data.message === `Room ${roomName} is now disabled`) {
        message.warning(`Session is now disabled for students`);
      }
      setTimeout(() => {
        navigate(-1);
      }, 800);
    } catch (error) {
      message.error(`Cannot exit the room.`);
    }
  };

  const showMeetingJoinedMsg = () => {
    message.success(`You have joined the live lecture as moderator`);
  };

  useEffect(() => {
    const fetchJwtToken = async () => {
      const params = new URLSearchParams();
      params.append('id', id);
      params.append('name', name);
      params.append('email', email);

      try {
        const response = await axios.post(`/jitsi/generate-token`, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
        setJwtToken(response.data);
      } catch (error) {
        console.error('Error fetching JWT token:', error);
      }
    };

    fetchJwtToken();
  }, []);

  return (
    <>
      {jwtToken !== '' && (
        <JitsiMeeting
          domain={YOUR_DOMAIN}
          roomName={roomName}
          configOverwrite={{
            prejoinPageEnabled: false,
            disableThirdPartyRequests: true,
            // disableLocalVideoFlip: false,
            backgroundAlpha: 0.5,
            disablePolls: true,
            whiteboard: {
              enabled: true,
              collabServerBaseUrl: 'https://excalidraw.com',
            },
            disableChats: true,
          }}
          interfaceConfigOverwrite={{
            VIDEO_LAYOUT_FIT: 'nocrop',
            MOBILE_APP_PROMO: false,
            TILE_VIEW_MAX_COLUMNS: 4,
          }}
          getIFrameRef={(iframeRef) => {
            iframeRef.style.height = '100vh';
          }}
          spinner={'Loading...'}
          onApiReady={(externalApi) => {
            externalApi.addListener('videoConferenceLeft', goBack);
            externalApi.addListener('videoConferenceJoined', showMeetingJoinedMsg);
          }}
        />

//         <JitsiMeeting
//   domain={YOUR_DOMAIN}
//   roomName={roomName}
//   configOverwrite={{
//     prejoinPageEnabled: false,
//     disableThirdPartyRequests: true,
//     backgroundAlpha: 0.5,
//     disablePolls: true,
//     whiteboard: {
//       enabled: true,
//       collabServerBaseUrl: 'https://excalidraw.com',
//     },
//     disableChats: true,
//   }}
//   interfaceConfigOverwrite={{
//     VIDEO_LAYOUT_FIT: 'nocrop',
//     MOBILE_APP_PROMO: false,
//     TILE_VIEW_MAX_COLUMNS: 4,
//   }}
//   getIFrameRef={(iframeRef) => {
//     iframeRef.style.height = '100vh';
//   }}
//   spinner={'Loading...'}
//   onApiReady={(externalApi) => {
//     // Log the entire externalApi object to the console
//     console.log("Jitsi Meet API Object:", externalApi);

//     externalApi.addListener('videoConferenceJoined', () => {
//       showMeetingJoinedMsg(); // Your custom function to display a message

//       // Additional functionality here
//     });

//     externalApi.addListener('videoConferenceLeft', goBack);
//   }}
// />


      )}
    </>
  );
};

export default JoinLiveLecture;
